import axios from "axios";

const API = process.env.REACT_APP_JOB_BOARD_API_URL;

// Stats cards
export const getEmployerStats = async (token) => {
  const res = await axios.get(`${API}/admin/employers/stats`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

// Employers table (filters + pagination)
export const getEmployers = async (params, token) => {
  const res = await axios.get(`${API}/admin/employers`, {
    params,
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

// KYC approve / reject
export const updateEmployerKyc = async (id, status, token) => {
  await axios.patch(
    `${API}/admin/employers/${id}/kyc`,
    { status },
    { headers: { Authorization: `Bearer ${token}` } }
  );
};

// Activate / Suspend
export const updateEmployerStatus = async (id, status, token) => {
  await axios.patch(
    `${API}/admin/employers/${id}/status`,
    { status },
    { headers: { Authorization: `Bearer ${token}` } }
  );
};

// Plan change
export const updateEmployerPlan = async (id, plan, token) => {
  await axios.patch(
    `${API}/admin/employers/${id}/plan`,
    { plan },
    { headers: { Authorization: `Bearer ${token}` } }
  );
};

// Bulk actions
export const bulkEmployerAction = async (payload, token) => {
  await axios.post(`${API}/admin/employers/bulk`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// Export
export const exportEmployers = async (token) => {
  const res = await axios.get(`${API}/admin/employers/export`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};
